import { Flex, Image, Input, styled, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAccessToken } from '../../apiservice/apiService';
import SamsungHRMLogo from '../../assets/images/bi-samsung.png';
import { PrimaryButton } from '../../components/Buttons';

const RootContainer = styled(Flex, {
  baseStyle: {
    minH: '100vh',
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'gray.50',
    gap: 8,
  },
});

const Logo = styled(Image, {
  baseStyle: {
    height: '40px',
    objectFit: 'contain',
  },
});

const RootPage = () => {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState('');
  const [uuid, setUuid] = useState('');

  const handleStartRemoteDiagnosis = () => {
    const params = new URLSearchParams();
    if (accessToken) {
      params.append('accessToken', accessToken);
    }
    if (uuid) {
      params.append('uuid', uuid);
    }

    const url = params.toString()
      ? `/front/remote-diagnosis?${params.toString()}`
      : '/front/remote-diagnosis';

    // Open in new tab
    window.open(url, '_blank');
  };

  const handleFetchToken = async () => {
    try {
      const token = await fetchAccessToken();
      // Only set access token if credentials are configured (for local testing)
      if (token && token.access_token) {
        setAccessToken(token.access_token);
      }
    } catch (error) {
      // Silently ignore errors - this feature is only for local testing
    }
  };

  useEffect(() => {
    handleFetchToken();
  }, []);
  return (
    <RootContainer>
      <Logo src={SamsungHRMLogo} alt="Samsung HRM" />

      <VStack spacing={4} width="300px">
        <VStack spacing={2} width="100%" align="start">
          <Text fontSize="sm" fontWeight="medium">
            Access Token
          </Text>
          <Input
            placeholder="Enter access token"
            value={accessToken}
            onChange={e => setAccessToken(e.target.value)}
            width="100%"
          />
        </VStack>

        <VStack spacing={2} width="100%" align="start">
          <Text fontSize="sm" fontWeight="medium">
            UUID
          </Text>
          <Input
            placeholder="Enter UUID"
            value={uuid}
            onChange={e => setUuid(e.target.value)}
            width="100%"
          />
        </VStack>

        <PrimaryButton onClick={handleStartRemoteDiagnosis} width="100%">
          Start Remote Diagnosis
        </PrimaryButton>
        <PrimaryButton onClick={handleFetchToken} width="100%" mb={2}>
          Fetch Access Token
        </PrimaryButton>
      </VStack>
    </RootContainer>
  );
};

export default RootPage;
